'use client';

import * as React from 'react';
import RadioGroupContext from './RadioGroupContext';
export default function useRadioGroup() {
  return React.useContext(RadioGroupContext);
}


//////////////////
// WEBPACK FOOTER
// ../@mui/material/RadioGroup/useRadioGroup.js
// module id = 946
// module chunks = 25